// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_hz-0";
export var actionModalContentContainer = "_hz-1";
export var createTagButton = "_hz-2";
export var footerContainer = "_hz-7";
export var fullWidthDivider = "_hz-3";
export var hasCreateTagButton = "_hz-4";
export var noCreateTagButton = "_hz-5";
export var tagsContainer = "_hz-6";
export var tagsModalContentContainer = "_hz-8";